{
	"handles": {
		"AR": "change_ar",
		"AU": "change.org_aus",
		"BR": "changeorg_br",
		"CA": "change.org_canada",
		"DE": "change.org_de",
		"ES": "change.org.es",
		"FR": "change.org_france",
		"IT": "change.org_italia",
		"MX": "changeorg_mx",
		"TR": "changetr",
		"UK": "change.org_uk",
		"US": "changedotorg"
	},
	"defaultHandle": "changedotorg"
}
